import {
  APPEND_SELECT_DATA,
  SET_SELECT_LOADING,
  RESET_SELECT_DATA,
  SEARCH_SELECT_REQUEST,
  SEARCH_SELECT_SUCCESS,
  SEARCH_SELECT_FAILURE,
  CLEAR_SEARCH_SELECT
} from './select-pagination-constants';
import { IReduxAction } from '../../../services/interfaces/common-interface';

const INITIAL_STATE: any = {};

export default function selectPaginationReducer(state = INITIAL_STATE, action: IReduxAction) {
  switch (action.type) {
    case SET_SELECT_LOADING: {
      const { resource, loading } = action.payload;
      return {
        ...state,
        [resource]: {
          ...(state[resource] || { data: [], skip: 0, hasMore: true }),
          loading: true
        }
      };
    }

    case APPEND_SELECT_DATA: {
      const { resource, items, hasMore } = action.payload;
      const current = state[resource]?.data || [];

      const merged = [
        ...current,
        ...items?.filter((newItem: any) => !current?.some((oldItem: any) => oldItem?._id === newItem?._id))
      ];

      return {
        ...state,
        [resource]: {
          ...state[resource],
          data: merged,
          hasMore,
          loading: false,
          skip: merged.length
        }
      };
    }

    case RESET_SELECT_DATA: {
      const { resource } = action.payload;
      return {
        ...state,
        [resource]: { data: [], skip: 0, hasMore: true, loading: false }
      };
    }

    case SEARCH_SELECT_REQUEST: {
      const { resource, searchTerm } = action.payload;
      return {
        ...state,
        [resource]: {
          ...(state[resource] || {}),
          searching: true,
          searchTerm
        }
      };
    }

    case SEARCH_SELECT_SUCCESS: {
      const { resource, data, searchTerm } = action.payload;
      return {
        ...state,
        [resource]: {
          ...(state[resource] || {}),
          searching: false,
          searchTerm,
          loading: false
        }
      };
    }

    case SEARCH_SELECT_FAILURE: {
      const { resource, error } = action.payload;
      return {
        ...state,
        [resource]: {
          ...(state[resource] || {}),
          searching: false,
          error,
          loading: false
        }
      };
    }
    case CLEAR_SEARCH_SELECT: {
      const { resource } = action.payload;
      return {
        ...state,
        [resource]: {
          ...(state[resource] || {}),
          searchTerm: '',
          searching: false
        }
      };
    }

    default:
      return state;
  }
}
